export default function updateCouponReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_COUPON_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_COUPON_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_COUPON_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}